import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, ErrorHandler } from '@angular/core';
import { HttpModule } from '@angular/http';
import { LocationStrategy, HashLocationStrategy, CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TabViewModule } from 'primeng/primeng';

import {
  PMVLayoutModule,
  PMVAuthenticationModule,
  PMVInterceptorsModule,
  PMVHeadersInterceptor,
  PMVServerPathInterceptor,
  PMVErrorHandler,
  PMVAuthenticationService,
} from 'pmv-common';

import { PSSAuthenticationModule } from './authentication/authentication.module';

import { environment } from '../environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { PMVCommonModule } from './shared/pmv-common.module';
import { ServicesModule } from './services/services.module';

import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';

import { AppConfig } from './app.config';
import { PSSAuthenticationService } from './authentication/authentication.service';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    ServicesModule,    
    TabViewModule,
    PSSAuthenticationModule.forRoot(),
    PMVLayoutModule,
    PMVAuthenticationModule.forRoot(),
    PMVInterceptorsModule.forRoot(environment.api),
    CommonModule,
    FormsModule,
    PMVCommonModule.forRoot()
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: PMVHeadersInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: PMVServerPathInterceptor, multi: true },
    { provide: ErrorHandler, useClass: PMVErrorHandler },
    { provide: PMVAuthenticationService, useClass: PSSAuthenticationService },
    AppConfig,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts